import './preauth.scss'
import { useContext, useEffect, useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import utility from 'src/utils/utility'
import access from 'src/utils/localAccess'

export const PreauthRoutes = () => {
    const navigate = useNavigate()
    const {info: {authToken}} = useContext(AppInfoContext)
    const [isAuth, setIsAuth] = useState<boolean>(!!authToken)

    useEffect(() => {
        access.setNavigationAccess(navigate)
        handleAuth()
    }, [])

    async function handleAuth () {
        let authToken = await localStorage.getItem('authToken')
        
        if (!authToken) setIsAuth(!!authToken)
        else navigate('/admin/dashboard')
    }
    
    return (
        <>
            { !isAuth &&
                <div className="preauth-container">
                    <Outlet/>
                </div>
            }
        </>
    )
}

export default utility.routeData('/', 'Preauth', <PreauthRoutes/>)
